module.exports = __webpack_public_path__ + "files/2825fceddbc18ba7fd4965875360d01f.png";